import type { LaunchDarklyFlags } from '@/common/launchDarkly';
import { useDS3Access } from './trial/use-ds3-access';

export const SUBSCRIPTION_RESTRICTED_EMAIL_BODY_LENGTH = 250;

export function useEmailLengthRestriction(flags: LaunchDarklyFlags, emailText: string | undefined) {
  const { hasDs3Access } = useDS3Access(flags);
  const isEmailLengthLimitEnabled = !!flags?.['is-email-length-limit-enabled'];

  const isEmailLengthLimitedBySubscription = isEmailLengthLimitEnabled && !hasDs3Access;

  const emailLength = emailText?.length ?? 0;
  const emailLengthPercent = (emailLength / SUBSCRIPTION_RESTRICTED_EMAIL_BODY_LENGTH) * 100;
  const isEmailAtLimit = emailLength >= SUBSCRIPTION_RESTRICTED_EMAIL_BODY_LENGTH;

  return {
    isEmailLengthLimitedBySubscription,
    emailLength,
    emailLengthPercent,
    isEmailAtLimit,
  };
}
